import { lazy } from 'react';

// Types
import { GoogleMapProps as LazyComponentProps } from './GoogleMap.types';

// Components
import withSuspense, { lazyRetry } from '../suspense';

const LazyComponent = lazy(() =>
  lazyRetry(() => import(/* webpackChunkName: "googleMap" */ './GoogleMap')),
);

const LazyComponentWithSuspense = withSuspense<LazyComponentProps>(LazyComponent, 'GoogleMap');

// Exports
export default LazyComponentWithSuspense;
export { LazyComponent as GoogleMap };
